import { render, staticRenderFns } from "./CommentSvg.vue?vue&type=template&id=fa177852&scoped=true&functional=true&"
var script = {}
import style0 from "./CommentSvg.vue?vue&type=style&index=0&id=fa177852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "fa177852",
  null
  
)

export default component.exports